import React from "react";
import PropTypes from "prop-types";
import "./Actualite.scss";
import event2 from "assets/Event2.webp";
import { connect } from "react-redux";
import { formatDate, truncate } from "Services/functions";
import parse from "html-react-parser";
import { HTMLParseOptions } from "Services/htmlParseOptions";
import { useIntersectionObserver } from "Services/intersectionObserver";

const API_LINK = process.env.REACT_APP_BASE_URL_API.split("/api")[0];
/**
 * Permet d'afficher la card d'une actualité
 * Elle est affichée dans les pages actus et detail-actu
 */
const Actualite = (props) => {
  const [intersectionRef, isVisibleIntersection] = useIntersectionObserver();

  const findLogo = () => {
    return (
      props.universities?.universitiesData?.find(
        (university) =>
          university.slug === props.newsDetails?.university?.slug ||
          university.slug === props.newsDetails?.universitySlug
      )?.imageTransparentAndColorUrl || ""
    );
  };

  const findUniversityName = () => {
    return (
      props.universities.universitiesData.find(
        (university) =>
          university.slug === props.newsDetails?.university?.slug ||
          university.slug === props.newsDetails?.universitySlug
      )?.name || ""
    );
  };

  const logo = findLogo();
  const universityName = findUniversityName();

  /**
   * Permet de :
   * - Remplacer les balises <br> par des espaces
   * - Tronquer le chapeau à 120 caractères
   * - Parser le chapeau en HTML
   *
   * @returns {string} Le chapeau de l'actualité modifié pour être prévisualisé
   */
  const sanitizeChapeau = () => {
    let chapeau = props?.chapeau?.replace(/<\/?br\s*\/?>/gi, " ");

    return parse(truncate(chapeau, 120), HTMLParseOptions);
  };

  return (
    <div
      className="actualite_container cardHoverActualite"
      style={{ minHeight: props?.random && "95.5%" }}
      onClick={() => {
        props.onClick && props.onClick();
      }}
      ref={intersectionRef}
    >
      <div className="actualite_container__top__categorie">
        <span className="etiquette"> {props.categorie} </span>
      </div>
      {isVisibleIntersection && (
        <div className="actualite_container__image">
          {props.url == "img1" ? (
            <>
              <img src={event2} alt="Fond news" loading="lazy" />
              <div
                className="image__bg"
                style={{ backgroundImage: `url(${event2})` }}
              ></div>
            </>
          ) : (
            <>
              <img
                src={ props.url}
                alt="Fond news"
                onError={(e) => {
                  e.target.src = event2;
                }}
                loading="lazy"
              />
              <div
                className="image__bg"
                style={{
                  backgroundImage: `url(${
                    props.url})`,
                  }}

              ></div>
            </>
          )}
        </div>
      )}
      <div className="actualite_container__corps">
        <div className="actualite_container__corps__debutdate">
          {formatDate(props.publicationDate) || props.publicationDate}
        </div>
        <div className="actualite_container__corps__title">
          {parse(truncate(props.title, 60))}
        </div>
        <div className="actualite_container__corps__chapeau">
          <span>{sanitizeChapeau()}</span>
        </div>
      </div>
      <div className="actualite_container__bottom">
        <div className="actualite_container__bottom__lien">Lire la suite</div>
        <div className="actualite_container__bottom__logo">
          <img
            src={API_LINK + logo}
            alt={"Logo Université " + universityName}
            title={"Logo Université " + universityName}
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
};

Actualite.propTypes = {
  categorie: PropTypes.string,
  title: PropTypes.string,
  date: PropTypes.string,
  chapeau: PropTypes.any,
  lien: PropTypes.string,
  logo: PropTypes.string,
  publicationDate: PropTypes.string,
  image: PropTypes.string,
  url: PropTypes.string,
  newsDetails: PropTypes.object,
  universities: PropTypes.object,
  random: PropTypes.bool,
  onClick: PropTypes.func,
  auth: PropTypes.object,
  nexusUrl: PropTypes.string,
};

const mapStateToProps = (state) => ({
  universities: state.universities,
  auth: state.auth,
});

const mapDispatchToProps = () => {};

export default connect(mapStateToProps, mapDispatchToProps)(Actualite);
